module.exports = __webpack_public_path__ + "static/media/dogFriendly.d699a296.svg";